import { MutationTree } from 'vuex';
import { UserState } from '@/ui/store/types/user-module.types';
import { iUser } from '@/entities/user/user.types';

export enum USER_MUTATIONS {
  SET_LOGGED_IN = 'SET_LOGGED_IN',
  SET_USER = 'SET_USER',
}

export const mutations: MutationTree<UserState> = {
  [USER_MUTATIONS.SET_LOGGED_IN](state, value: boolean) {
    state.user.loggedIn = value;
  },
  [USER_MUTATIONS.SET_USER](state, data: iUser) {
    state.user.data = data;
  },
};
